import { render, staticRenderFns } from "./MailButton.vue?vue&type=template&id=67c32d61"
import script from "./MailButton.vue?vue&type=script&lang=ts"
export * from "./MailButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports